import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'src/app/services/cookie.service';

@Component({
  selector: 'app-cookie-preferences',
  templateUrl: './cookie-preferences.component.html',
  styleUrls: ['./cookie-preferences.component.scss']
})
export class CookiePreferencesComponent {
  cookieService = inject(CookieService);
  router = inject(Router);
  isTerzePartiChecked: boolean = true;


  onTerzePartiChange() {
    this.cookieService.consent.categories.multimedia.wanted = !this.cookieService.consent.categories.multimedia.wanted;
  }

  saveSettings() {
    this.cookieService.setCookie('cookie_consent', this.cookieService.consent, 365);
    this.goToHome();

  }
  goToHome() {
    this.router.navigate(['/']);
  }

  acceptAllCookies() {
    this.cookieService.consent.categories.multimedia.wanted = true;
    this.cookieService.setCookie('cookie_consent', this.cookieService.consent, 365);
    this.goToHome();
  }
  refuseAllCookies() {
    //this.cookieService.consent.categories.necessary.wanted = false;
    this.cookieService.consent.categories.multimedia.wanted = false;
    this.cookieService.setCookie('cookie_consent', this.cookieService.consent, 365);

    this.goToHome();
  }
}
